import { z } from "zod";

export const LoginFormSchema = z.object({
  email: z.string().email({ message: "無効なメールアドレスです" }),
  password: z.string().min(6, { message: "パスワードは6文字以上である必要があります" }),
});

export type LoginFormSchemaValue = z.infer<typeof LoginFormSchema>;
